import { INITIALAIZE_REQUEST, SLUG_SUCCESS, PUT_SUCCESS, INITIALAIZE_FAILURE } from './types';

const initialState = {
    loading: false,
    slug: '',
    data: '',
    error: ''
}

const project = (state = initialState, action) => {
    switch (action.type) {
        case INITIALAIZE_REQUEST:
            return {
                ...state,
                loading: true,
                error: ''
            }
        case SLUG_SUCCESS:
            return {
                ...state,
                loading: false,
                slug: action.payload,
            }
        case PUT_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            }
        case INITIALAIZE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            }
        default:
            return state
    }
}

export default project;